import { useMutation, useQuery } from '@apollo/client';
import { Grid, List } from '@material-ui/core';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import AddIcon from '@material-ui/icons/Add';
import { GET_ALL_CATEGORIES, SORT_CATEGORY } from '../gql/categories';
import Note from './layout/Note';
import Loading from './layout/Loading';
import PageContainer from './layout/PageContainer';
import PagePaper from './layout/PagePaper';
import CategoriesItem from './CategoriesItem';
import handleArrayToggle from '../utils/handleArrayToggle';
import CategoryDelete from './CategoryDelete';

const { REACT_APP_UPLOAD_PATH, REACT_APP_SERVER_NAME } = process.env;

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const Categories = () => {
  const { loading, error, data } = useQuery(GET_ALL_CATEGORIES, {
    fetchPolicy: 'network-only',
  });
  const [sortLoading, setSortLoading] = useState([]);
  const [checked, setChecked] = useState([]);
  const [sortCategory] = useMutation(SORT_CATEGORY, {
    refetchQueries: [{ query: GET_ALL_CATEGORIES }],
    onCompleted({ sortCategory: { id } }) {
      handleArrayToggle(id, sortLoading, setSortLoading);
      setChecked([]);
    },
  });
  const classes = useStyles();
  const [deleteCategory, setDeleteCategory] = useState({
    id: '',
    folderName: '',
  });
  const [openDelete, setOpenDelete] = useState(false);
  const handleSort = () => {
    checked.map((id) => {
      sortCategory({
        variables: { id },
      });
      handleArrayToggle(id, sortLoading, setSortLoading);
    });
  };
  if (loading) return <Loading />;
  if (error) {
    console.log(`Error! ${error}`);
    return `Error! ${error}`;
  }
  return (
    <>
      <PageContainer title="Categories">
        <Note>
          {`Summary and mainenance of categories, to upload file, please put them
          into
          ${REACT_APP_UPLOAD_PATH}@${REACT_APP_SERVER_NAME}`}
        </Note>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <PagePaper>
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  component={Link}
                  to="/categories/add"
                  className={classes.button}
                  startIcon={<AddIcon />}
                >
                  add category
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleSort}
                  className={classes.button}
                  startIcon={<PublishIcon />}
                >
                  sort files
                </Button>
              </div>
              <List>
                {data.categories.map((category) => (
                  <CategoriesItem
                    key={category.id}
                    category={category}
                    checked={checked}
                    setChecked={setChecked}
                    sortLoading={sortLoading}
                    setDeleteCategory={setDeleteCategory}
                    setOpenDelete={setOpenDelete}
                  />
                ))}
              </List>
            </PagePaper>
          </Grid>
        </Grid>
      </PageContainer>
      <CategoryDelete
        open={openDelete}
        setOpen={setOpenDelete}
        category={deleteCategory}
      />
    </>
  );
};

export default Categories;
